namespace SP.Data {
    export class QuickProduction {

        static async getInfo(orderCount: number, totalOnly: boolean) {
            var response = await SP.get<any>("/api/v1/production/quickInfo/?OrderQty=" + orderCount + "&TotalOnly=" + totalOnly);
            if (response.status == 200) return response.data as ProductionQuickInfo;
            else await SP.alertX(response.status + ": " + response.msg);
            return null;
        }
      
    }
}